var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mini-compare" }, [
    _c("div", { staticClass: "range-form-item-inner" }, [
      _c("div", { staticClass: "form-data-a" }, [
        _c("div", { staticClass: "box-centered" }, [
          _c("div", { staticClass: "load-data" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.sum,
                  expression: "sum"
                }
              ],
              attrs: { type: "hidden", max: "400" },
              domProps: { value: _vm.sum },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.sum = $event.target.value
                }
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ranges-slider__blck" },
        [
          [
            _c("range-slider", {
              staticClass: "slider",
              attrs: { min: 1000, max: 30000, step: 1000 },
              model: {
                value: _vm.electricity,
                callback: function($$v) {
                  _vm.electricity = $$v
                },
                expression: "electricity"
              }
            })
          ],
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "slider__scales2" },
            _vm._l(_vm.separators, function(separator, num) {
              return _c(
                "div",
                {
                  staticClass: "scale_item",
                  class: { active: null !== separator.label },
                  style: "left:" + separator.percent + "%"
                },
                [
                  _vm._m(0, true),
                  _vm._v(" "),
                  null !== separator.label
                    ? _c(
                        "button",
                        {
                          staticClass: "data__blck",
                          staticStyle: { left: "-20px" },
                          on: {
                            click: function($event) {
                              return _vm.setRangeValue(num)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(separator.label))])]
                      )
                    : _vm._e()
                ]
              )
            }),
            0
          )
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row home-form" }, [
      _c("div", { staticClass: "col-md-12 d-flex align-items-stretch" }, [
        _c("div", { staticClass: "info__blck" }, [
          _c(
            "div",
            {
              staticClass: "form-group error electricity",
              class: { active: _vm.checkClass(_vm.electricity) }
            },
            [
              _c(
                "label",
                {
                  staticClass: "min-min p-white",
                  on: {
                    click: function($event) {
                      return _vm.forLabelClick($event)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../../../../img/icon/exclamation-sign.svg"),
                      alt: ""
                    }
                  }),
                  _vm._v("Electricity/year")
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.electricity,
                    expression: "electricity",
                    modifiers: { number: true }
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", title: "Electricity consumption/year" },
                domProps: { value: _vm.electricity },
                on: {
                  focus: function($event) {
                    return _vm.formControlFocus($event)
                  },
                  blur: [
                    function($event) {
                      return _vm.formControlBlur($event)
                    },
                    function($event) {
                      return _vm.$forceUpdate()
                    }
                  ],
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.electricity = _vm._n($event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c("small", [_vm._v("kWh")])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-12 d-flex align-items-stretch" }, [
        _c("div", { staticClass: "info__blck" }, [
          _c("div", { staticClass: "form-group error postcode" }, [
            _c(
              "label",
              {
                staticClass: "min-min p-white",
                on: {
                  click: function($event) {
                    return _vm.forLabelClick($event)
                  }
                }
              },
              [
                _c("img", {
                  attrs: {
                    src: require("../../../../img/icon/exclamation-sign.svg"),
                    alt: ""
                  }
                }),
                _vm._v("Your postcode")
              ]
            ),
            _vm._v(" "),
            _c("input", {
              staticClass: "form-control",
              attrs: { type: "text", title: "Electricity consumption/year" },
              on: {
                focus: function($event) {
                  return _vm.formControlFocus($event)
                },
                blur: function($event) {
                  return _vm.formControlBlur($event)
                }
              }
            }),
            _vm._v(" "),
            _vm._m(1)
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(2)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "item" }, [_c("span")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cntry_name" }, [
      _c("span", { staticClass: "marker" }, [
        _c("img", { attrs: { src: "/img/marker.svg", alt: "" } })
      ]),
      _vm._v("Stockholm")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-md-12 p-center" }, [
          _c("p", { staticClass: "p-green med mb-0" }, [
            _vm._v("You save in average: "),
            _c("b", [_vm._v("500 kr/year")]),
            _vm._v(" by using "),
            _c("b", [_vm._v("TecknaEl.se")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-md-10" }, [
          _c("div", { staticClass: "compare-btn" }, [
            _c("button", { staticClass: "btn btn-green btn-full" }, [
              _vm._v("Compare prices")
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }